import getContentUrl from "utils-lib/getContentUrl"
import Typography from "component-lib/Base/components/Typography"
import { getWindow } from "utils-lib/getWindow"
import { Link } from "../../../Base"
import "./sevenCard.scss"

const ssrWindow = getWindow()

const Gridcard = (cardList) => {
  const bodyWidth =
    ssrWindow.innerWidth > 0 ? ssrWindow.innerWidth : ssrWindow.screen.width

  return (
    <div
      data-testid="GridcardWrapper"
      className={`GridcardWrapper  ${
        cardList?.cardList?.cardImage ? "Gridcard" : ""
      } m-0`}
    >
      {cardList?.cardList?.cardImage ? (
        <img
          className="pb-4 contentcardimage"
          src={getContentUrl(cardList?.cardList?.cardImage)}
          alt=""
          aria-hidden="true"
        />
      ) : (
        ""
      )}
      <hr aria-hidden="true" />
      <div
        className={`${
          cardList?.cardList?.cardImage
            ? "WmcontentcardwithImage"
            : "WmcontentcardwithoutImage"
        }`}
      >
        <div className="maax-font-weight-bold cardItemtitle">
          {cardList?.cardList?.cardEyebrowText}
        </div>
        <Typography
          className="cardHeading maax-font-weight-bold"
          variant={bodyWidth < 1025 ? "h4" : "h3"}
          style={{ color: "black" }}
          data-testid="Gridcard-cardHeading"
          aria-hidden="true"
        >
          {cardList?.cardList?.cardHeading}
        </Typography>
        <div
          className="flex-grow-1 cardItemsubText maax-font-weight-regular"
          data-testid="Gridcard-cardBody"
        >
          {cardList?.cardList?.cardBody}
        </div>
        <Link
          overrideClass="maax-font-weight-regular"
          href={cardList?.cardList?.cardCtaURL}
          isExternalLink={cardList?.cardList?.externalLink}
          analytics_key={
            cardList?.cardList?.analyticsKey ||
            `${cardList?.cardList?.cardHeading} ${cardList?.cardList?.cardCtaText} ${cardList?.cardList?.cardCtaURL}`
          }
          style={{ position: cardList?.cardList?.cardImage ? "" : "absolute" }}
          data-testid="Gridcard-cardCtaText"
          tabIndex={0}
          aria-hidden="true"
        >
          {cardList?.cardList?.cardCtaText}
        </Link>
      </div>
    </div>
  )
}
export default Gridcard
